<template>
  <v-tooltip interactive>
    <template v-slot:activator="{ props: activatorProps }">
      <v-icon
        style=" font-size: 24px;opacity: var(--v-medium-emphasis-opacity)"
        icon="mdi-information-outline"
        v-bind="{...activatorProps, ...$attrs}" />
    </template>
    <v-card>
      <v-card-item>
        {{props.title}}
          <v-icon  v-if="authStore.isSuperUser"
            icon="mdi-pencil"
            @click="tooltipEditDialog = true"></v-icon>
      </v-card-item>
      <v-card-text>
        <span>{{ v.description }}</span>
        <MathField
          :model-value="v.formula"
          read-only />
        <span>{{ v.legend }}</span>
      </v-card-text>
    </v-card>
    <edit-tooltip
      v-model="tooltipEditDialog"
      :name="props.name" />
  </v-tooltip>
</template>
<script lang="ts" setup>
import { computed, ref } from "vue";
import { useMainStore } from "@/stores/mainStore";
import MathField from "../Elements/MathField.vue";
import EditTooltip from "../dialogs/EditTooltip.vue";
import { useAuthStore } from "@/stores/authStore";

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: false
  },
});

const authStore = useAuthStore();
const mainStore = useMainStore();

const v = computed(() => {
  return mainStore.tooltips[props.name] || {};
});

const tooltipEditDialog = ref(false);
</script>
